import { useEffect, useState } from 'react';
import { moduleClientFactory } from '../../../../api-service/module-client-factory';
import { useAuthenticatedUser } from '../../../../authentication/auth-wrapper';

const organizationClient = moduleClientFactory.createOrganizationClient();

type ResponsibleUser = {
  userId: string;
  teamId?: string;
};

export function useCurrentUserResponsible() {
  const authenticatedUser = useAuthenticatedUser();
  const [responsibleUser, setResponsibleUser] = useState<ResponsibleUser>();

  useEffect(() => {
    async function loadCurrentUser() {
      if (!authenticatedUser?.profile.id) return;

      const response = await organizationClient.getUserById({ userId: authenticatedUser.profile.id });
      if (response.user?.id) {
        setResponsibleUser({
          userId: response.user.id,
          teamId: response.user.teamId,
        });
      }
    }
    loadCurrentUser();
  }, [authenticatedUser?.profile.id]);

  return responsibleUser;
}
